import { Component } from "react";
import PropTypes from "prop-types";

export default class FeedItemComponent extends Component {
  constructor() {
    super();
    this.state = {
      hideClass: "",
    };
  }

  componentDidMount() {
    this.setState({
      hideClass: `hide-${this.props.side}`,
    });
    setTimeout(() => {
      this.setState({
        ...this.props,
        hideClass: "",
      });
    }, 500);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.setState({
        hideClass: `hide-${this.props.side}`,
      });
      setTimeout(() => {
        this.setState({
          ...this.props,
          hideClass: "",
        });
      }, this.props.animationDuration * 1000);
    }
  }

  render() {
    const {
      logo,
      fullName,
      verticalAlign,
      horizontalAlign,
      textPosition,
      hideClass,
    } = this.state;

    return (
      <div
        className={`feed-item vertical-align-${verticalAlign} horizontal-align-${horizontalAlign} ${hideClass}`}
        style={{
          transitionDuration: `${this.props.animationDuration}s`,
        }}
      >
        <div className={`feed-content text-position-${textPosition}`}>
          {logo && logo.length > 0 && (
            <div
              className={`team-logo`}
              style={{
                backgroundImage: `url(${logo})`,
              }}
            />
          )}
          <div className="team-meta-info">
            <div className="team-info-name">{fullName}</div>
          </div>
        </div>
      </div>
    );
  }
}

FeedItemComponent.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fullName: PropTypes.string,
  logo: PropTypes.string,
  verticalAlign: PropTypes.oneOf(["center", "top", "bottom"]),
  horizontalAlign: PropTypes.oneOf(["center", "left", "right"]),
  textPosition: PropTypes.oneOf(["top", "bottom"]),
  animationDuration: PropTypes.number,
  side: PropTypes.oneOf(["left", "right"]),
};

FeedItemComponent.defaultProps = {
  id: "-1",
  fullName: "Team A",
  logo: "",
  verticalAlign: "center",
  horizontalAlign: "center",
  textPosition: "bottom",
  animationDuration: 1,
  side: "left",
};
